import type { PrimitiveType } from '#layers/data-model/types/schema/primitive-type';
import { getTimezoneSelectOptions, resolveTimezone, TIMEZONE_LOCAL, TIMEZONE_UTC } from '#layers/base/public';
import { BuiltinBlockIds } from '#layers/data-model/constants/builtin-block-ids';
import { isEpochIntegerPrimitiveTypeName, PRIMITIVE_TYPE_DATE_TIME_WITH_TIMEZONE } from '#layers/data-model/constants/schema/primitive-type';
import { getTypename } from '#layers/data-model/utils/schema/primitive-type';

export function getDatetimePrimitiveSemantics(primitiveTypeName?: PrimitiveType['name'] | string | null) {
	const isTimestamp = isEpochIntegerPrimitiveTypeName(primitiveTypeName);
	const isTimezoneType = primitiveTypeName === PRIMITIVE_TYPE_DATE_TIME_WITH_TIMEZONE;

	return {
		isInstantType: isTimezoneType || isTimestamp,
		isTimestamp,
		isTimezoneType,
	};
}

function getDefaultTimezoneFormField() {
	return {
		name: 'defaultTimezone',
		label: '$t:field_types.datetime.options.default_timezone.label',
		description: '$t:field_types.datetime.options.default_timezone.description',
		block: BuiltinBlockIds.InputSelect,
		props: {
			options: getTimezoneSelectOptions(),
			placeholder: '$t:field_types.datetime.options.local',
		},
	};
}

interface GetDefaultTimezoneFormFieldsOptions {
	includeWhenPrimitiveTypeUnknown?: boolean;
}

export function getDefaultTimezoneFormFields(
	primitiveType?: PrimitiveType | null,
	options: GetDefaultTimezoneFormFieldsOptions = {},
) {
	if (!primitiveType && options.includeWhenPrimitiveTypeUnknown) {
		return [getDefaultTimezoneFormField()];
	}

	if (!primitiveType || !getDatetimePrimitiveSemantics(getTypename(primitiveType)).isInstantType) {
		return [];
	}

	return [getDefaultTimezoneFormField()];
}

export function resolveDatetimeTimezone(isInstantType: boolean, defaultTimezone?: string): string {
	if (!isInstantType) {
		return TIMEZONE_UTC;
	}

	return resolveTimezone(defaultTimezone?.trim() || TIMEZONE_LOCAL);
}
